export const GET_IMG_BBOX_RUN_DATA='GET_IMG_BBOX_RUN_DATA';
export const GET_IMG_BBOX_RUN_DATA_ERROR='GET_IMG_BBOX_RUN_DATA_ERROR';
export const GET_IMG_BBOX_DATASET_DATA='GET_IMG_BBOX_DATASET_DATA';
export const GET_IMG_BBOX_DATASET_DATA_ERROR='GET_IMG_BBOX_DATASET_DATA_ERROR';


// WEBPACK FOOTER //
// ./src/redux/imgbbox/actionTypes.js